export default __webpack_public_path__ + "static/media/Group 3204@2x.c7bc85e2.png";